import { createContext, useContext } from "react";
import type { PanelPlacement } from "../agent/panelPlacement";

type PanelLayout = {
  placement: PanelPlacement | null;
};

export const PanelLayoutContext = createContext<PanelLayout>({ placement: null });

export const usePanelLayout = () => useContext(PanelLayoutContext);

export const besidePanelWidthPx = (placement: PanelPlacement | null) =>
  placement?.kind === "beside" ? placement.widthPx : 0;

export const menuForcedToIcons = (placement: PanelPlacement | null) =>
  placement?.kind === "beside" && placement.menu === "icons";
